import UserModel from '../../../models/UserModel';
import SessionModel from '../../../models/secure/SessionModel';

const setUser = (context, payload) => {
    context.commit('SET_USER', payload);
}

const clearUser = (context) => {
    context.commit('CLEAR_USER');
}

const setAuthorizedUser = (context, payload) => {
    context.commit('SET_AUTHORIZED_USER', payload);
}

const clearAuthorizedUser = (context) => {
    context.commit('CLEAR_AUTHORIZED_USER');
}

const setSession = (context, payload) => {
    context.commit('SET_SESSION', payload);
}

const clearSession = (context, payload) => {
    context.commit('CLEAR_SESSION', payload);
}

const setPathIntention = (context, payload) => {
    context.commit('SET_PATH_INTENTION', payload);
}

const clearPathIntention = (context) => {
    context.commit('CLEAR_PATH_INTENTION');
}

const clearStates = (context) => {
    context.commit('CLEAR_STATES');
};
// Required: payload = sessionId value
const checkSession = async (context, payload) => {
    let sessionModel = new SessionModel();
    return sessionModel.checkSession({ sessionId: payload }).then(res => {
        return (res.data && res.data.status && res.data.status == 'active');
    }).catch(err => {
        console.log(err, "error while checking session");
        return false;
    });
}

const authenticate = async (context, payload) => {
    let userModel = new UserModel();
    return userModel.authenticate({
        email: payload.email, 
        password: payload.password,
        osName: payload.osName,
        browserVersion: payload.browserVersion,
        browserDimension: payload.browserDimension
    }).then(res => {
        if(res.data && res.data.session_id){
            context.commit('SET_SESSION', res.data.session_id);
            context.commit('SET_USER', payload.email);
            return res.data;
        } else {
            return {
                status: res.data.status,
                status_code: res.data.status_code,
                description: res.data.description + ": email/password doesn't match/exist"
            };
        }
    }).catch(err => {
        return {
            status: "ERROR",
            status_code: "ERR1",
            description: err + " - Failed to connect to server for authentication"
        };
    });
}

const authenticateAuthorizedUser = async (context, payload) => {
    let sessionModel = new SessionModel();
    return sessionModel.authorizedUserAuth({
        email: payload.email, 
        password: payload.password,
        sessionId: payload.sessionId
    }).then(res => {
        if(res.data && res.data.session_id){
            context.commit('SET_SESSION', res.data.session_id);
            context.commit('SET_USER', payload.email);
            return res.data;
        } else {
            return {
                status: res.data.status,
                status_code: res.data.status_code,
                description: res.data.description + ": email/password doesn't match/exist"
            };
        }
    }).catch(err => {
        return {
            status: "ERROR",
            status_code: "ERR1",
            description: err + " - Failed to connect to server for authentication"
        };
    });
}

// Payload required: id (as sessionId) value, email value
const fetchUserDetails = async (context, payload) => {
    let sessionModel = new SessionModel();
    return sessionModel.userDetails({ id: payload.sessionId, email: payload.email }).then(res => {
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            status_code: "ERR1",
            description: err + " - Failed to connect to server for authentication"
        };
    });
}

// Payload required: userId, sessionId, action
const verifyAccess = async (context, payload) => {
    let sessionModel = new SessionModel();
    return sessionModel.verifyAccess({ userId: payload.userId, sessionId: payload.sessionId , action: payload.action}).then(res => {
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            status_code: "ERR1",
            description: err + " - Failed to connect to server for authentication"
        };
    });
}

// Payload required: sessionId value
const fetchSessionDetails = async (context, payload) => {
    let sessionModel = new SessionModel();
    return sessionModel.sessionDetails({ sessionId: payload }).then(res => {
        if (res.data && res.data.status == SessionModel.STATUS_SUCCESS) {
            context.commit('SET_SESSION_DETAILS', res.data.records);
        } else {
            context.commit('CLEAR_SESSION_DETAILS');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            status_code: "ERR1",
            description: err + " - Failed to connect to server for authentication"
        };
    });
}

const clearSessionDetails = (context) => {
    context.commit('CLEAR_SESSION_DETAILS');
}

// Payload required: email value, sessionId value, targetUser value
const impersonateUser = async (context, payload) => {
    let sessionModel = new SessionModel();
    return sessionModel.impersonateSession({ email: payload.email, sessionId: payload.sessionId, userValue: payload.targetUser }).then(res => {
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            status_code: "ERR1",
            description: err + " - Failed to connect to server for authentication"
        };
    });
}

const register = async (context, payload) => {
    let userModel = new UserModel();
    return userModel.register({
        name: payload.name,
        email: payload.email, 
        password: payload.password,
        role: 21
    });
}

// Payload required: { userId: value, sessionId: value }
const expire = async (context, payload) => {
    let sessionModel = new SessionModel();
    return sessionModel.expire(payload).then(res => {
        return res.data;
    }).catch(err => {
        return UserModel.defaultError(err);
    });
}

const setCancelPurchase = (context, payload) => {
    context.commit('SET_CANCEL_PURCHASE', payload);
}

const clearCancelPurchase = (context) => {
    context.commit('SET_CANCEL_PURCHASE');
}

export {
    setUser,
    clearUser,
    setAuthorizedUser,
    clearAuthorizedUser,
    setSession,
    clearSession,
    setPathIntention,
    clearPathIntention,
    clearStates,
    checkSession,
    authenticate,
    authenticateAuthorizedUser,
    fetchUserDetails,
    verifyAccess,
    fetchSessionDetails,
    clearSessionDetails,
    impersonateUser,
    register,
    expire,
    setCancelPurchase,
    clearCancelPurchase
}
